import { DefaultEstate, EstateModel } from "../helpers/estate";
import { action, makeObservable, observable } from "mobx";


export interface ReplenishmentHistoryStore {
    estate: EstateModel;
    setEstate: (estate: EstateModel) => void;
    responseCache: ResponseCache;
    setResponseCache: (responseCacheToSave: ResponseCache) => void;
}

export class ResponseCache {
    @observable suggestionNumber: number;

    constructor(suggestionNumber: number) {
        this.suggestionNumber = suggestionNumber;
    }
}

export class DefaultReplenishmentHistoryStore implements ReplenishmentHistoryStore {

    constructor() {
        makeObservable(this);
    }

    @observable
    private _estate: EstateModel = new DefaultEstate();

    @observable
    private _responseCache: ResponseCache = new ResponseCache(0);

    @action
    public setEstate(estate: EstateModel) {
        this._estate = JSON.parse(JSON.stringify(estate));
    }

    @action
    public setResponseCache(responseCacheToSave: ResponseCache) {
        this._responseCache = JSON.parse(JSON.stringify(responseCacheToSave));
    }
    get estate(): EstateModel {
        return this._estate;
    }

    set estate(value: EstateModel) {
        this._estate = value;
    }

    get responseCache(): ResponseCache {
        return this._responseCache;
    }

    set responseCache(value: ResponseCache) {
        this._responseCache = value;
    }
}
